import { render } from "./BlankView.vue?vue&type=template&id=31573aae"
const script = {}

import exportComponent from "/Users/storywriter/projects/webtan_event/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__